import { signature } from './components/signature'
import { autofill } from './components/autofill'

import { validation } from './requests/validation'
import { form } from './requests/form'

signature.init()
autofill.init()

validation.init()
form.init()